// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { jsonArrayMember, jsonObject } from "typedjson";
import { MessageType, MessageTypeName } from "./messageTypes";

@jsonObject
export default class SendNervTxResponse extends PerunMessage {
  @jsonArrayMember(String) witness: string[];

  constructor(witness: string[]) {
    super();
    this.witness = witness;
  }

  messageType(): MessageType {
    return SendNervTxResponse;
  }

  messageTypeName(): MessageTypeName {
    return "SendNervTxResponse";
  }
}
